// the player profile Alpine object
window.appPlayerProfile = playerId => {
    return {
        activeTab: 'profile',
        // activeTab: 'graph',
        note: '',
        status: 'default',
        init: function() {
            // load in the player note
            this.getNote();

            this.$nextTick( () => {
                // set the initial season for the radar graph
                // this is the first eleigible season from the list of seasons available
                $c_raw('selectRadarSeasonId').items.some( item => {
                    if( item.value !== 0 ) {
                        this.$component('selectRadarSeasonId').set(item);
                        return true;
                    }
                })
                // set the initial season for the scatter graph
                // this is the first eleigible season from the list of seasons available
                $c_raw('selectGraphSeasonId').items.some( item => {
                    if( item.value !== 0 ) {
                        this.$component('selectGraphSeasonId').set(item);
                        return true;
                    }
                })
                // set the initial season for the player minutes
                $c_raw('selectMinutesSeasonId').items.some( item => {
                    if( item.value !== 0 ) {
                        this.$component('selectMinutesSeasonId').set(item);
                        return true;
                    }
                })
                // set the initial season for the player positions
                $c_raw('selectPositionSeasonId').items.some( item => {
                    if( item.value !== 0 ) {
                        this.$component('selectPositionSeasonId').set(item);
                        return true;
                    }
                })
            });
        },

        // get the note for this player
        getNote: function() {
            axios.get('/api/player-note/' + playerId )
                .then( response => {
                    this.note = response.data;
                })
                .catch( ajaxFail )
        },

        // save a note for this player
        saveNote: function() {
            this.status = 'saving';
            axios.put('/api/player-note/' + playerId, {
                note: this.note
            })
                .then()
                .catch( ajaxFail )
                .then( () => {
                    this.status = 'saved';
                    setTimeout( () => {
                        this.status = 'default';
                    }, 3000)
                })
        }
    }
};
